'use strict';

var _barba = require('barba.js');

var _barba2 = _interopRequireDefault(_barba);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _themeSections = require('@shopify/theme-sections');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var indexUrl = (0, _jquery2.default)('.show-index').attr('href');

var Homepage = _barba2.default.BaseView.extend({
    namespace: 'homepage',
    onEnter: function onEnter() {
        // The new Container is ready and attached to the DOM.
        var event = new Event('homepage');
        document.dispatchEvent(event);
    },
    onEnterCompleted: function onEnterCompleted() {
        // The Transition has just finished.
        console.log('homepage');
    },
    onLeave: function onLeave() {
        // A new Transition toward a new page has just started.

    },
    onLeaveCompleted: function onLeaveCompleted() {
        // The Container has just been removed from the DOM.

    }
});

var Product = _barba2.default.BaseView.extend({
    namespace: 'product',
    onEnter: function onEnter() {
        // The new Container is ready and attached to the DOM.
        var event = new Event('product');
        document.dispatchEvent(event);
        (0, _themeSections.load)('product');
    },
    onEnterCompleted: function onEnterCompleted() {
        // The Transition has just finished.
        console.log('product');
    },
    onLeave: function onLeave() {
        // A new Transition toward a new page has just started.

    },
    onLeaveCompleted: function onLeaveCompleted() {
        // The Container has just been removed from the DOM.

    }
});

var Index = _barba2.default.BaseView.extend({
    namespace: 'index',
    onEnter: function onEnter() {
        // The new Container is ready and attached to the DOM.
        var event = new Event('index');
        document.dispatchEvent(event);
    },
    onEnterCompleted: function onEnterCompleted() {
        // The Transition has just finished.
        console.log('index');
    },
    onLeave: function onLeave() {
        // A new Transition toward a new page has just started.

    },
    onLeaveCompleted: function onLeaveCompleted() {
        // The Container has just been removed from the DOM.

    }
});

var Cart = _barba2.default.BaseView.extend({
    namespace: 'cart',
    onEnter: function onEnter() {
        // The new Container is ready and attached to the DOM.
        var event = new Event('cart');
        document.dispatchEvent(event);
    },
    onEnterCompleted: function onEnterCompleted() {
        // The Transition has just finished.
        console.log('cart');
    },
    onLeave: function onLeave() {
        // A new Transition toward a new page has just started.

    },
    onLeaveCompleted: function onLeaveCompleted() {
        // The Container has just been removed from the DOM.

    }
});

Homepage.init();
Product.init();
Index.init();
Cart.init();

_barba2.default.Pjax.Dom.wrapperId = 'MainContent';
_barba2.default.Pjax.start();
_barba2.default.Prefetch.init();

_barba2.default.Dispatcher.on('linkClicked', function () {
    (0, _jquery2.default)(window).off('scroll');
});

_barba2.default.Dispatcher.on('newPageReady', function () {
    (0, _jquery2.default)('.barba-container').eq(1).hide();
    productItems();
});

productItems();
function productItems() {
    if ((0, _jquery2.default)('.product-item').length > 0) {
        (0, _jquery2.default)('.p-trigger, .product-item img').on('mouseover', function (e) {
            e.stopPropagation();
            (0, _jquery2.default)(this).closest('.product-item').addClass('over');
        }).on('mouseout', function () {
            (0, _jquery2.default)(this).closest('.product-item').removeClass('over');
        });
    }
}

document.addEventListener('goTo', function (e) {
    _barba2.default.Pjax.goTo(e.detail);
});

var FadeTransition = _barba2.default.BaseTransition.extend({
    start: function start() {
        Promise.all([this.newContainerLoading, this.fadeOut()]).then(this.fadeIn.bind(this));
    },

    fadeOut: function fadeOut() {
        var $el = (0, _jquery2.default)(this.newContainer);
        return (0, _jquery2.default)(this.oldContainer).animate({ opacity: 0 }, 200).promise();
    },

    fadeIn: function fadeIn() {

        var _this = this;
        var $el = (0, _jquery2.default)(this.newContainer);

        (0, _jquery2.default)(this.oldContainer).hide();

        $el.css({
            visibility: 'visible',
            opacity: 0
        });

        (0, _jquery2.default)('body').removeClass().addClass('template-' + $el.data('namespace')).attr('id', '').scrollTop(0);

        $el.show();

        $el.animate({ opacity: 1 }, 200, function () {
            _this.done();
        });
    }
});

var ToggleTransition = _barba2.default.BaseTransition.extend({
    start: function start() {
        Promise.all([this.newContainerLoading, this.fadeOut()]).then(this.fadeIn.bind(this));
    },

    fadeOut: function fadeOut() {
        var $el = (0, _jquery2.default)(this.newContainer);
        return (0, _jquery2.default)(this.oldContainer).animate({ opacity: 0 }, 0).promise();
    },

    fadeIn: function fadeIn() {

        var _this = this;
        var $el = (0, _jquery2.default)(this.newContainer);

        (0, _jquery2.default)(this.oldContainer).hide();

        $el.css({
            visibility: 'visible',
            opacity: 0
        });

        (0, _jquery2.default)('body').removeClass().addClass('template-' + $el.data('namespace')).attr('id', '').scrollTop(0);

        $el.show();

        $el.animate({ opacity: 1 }, 0, function () {
            _this.done();
        });
    }
});

_barba2.default.Pjax.getTransition = function (e) {
    /**
     * Here you can use your own logic!
     * For example you can use different Transition based on the current page or link...
     */

    var url = _barba2.default.HistoryManager.currentStatus().url;
    var prev_url = _barba2.default.HistoryManager.prevStatus().url;

    console.log('url ' + url);
    console.log('prev_url ' + prev_url);

    if (url.indexOf('index') == -1 && prev_url.indexOf('index') == -1) {
        console.log('fade');
        return FadeTransition;
    } else {
        console.log('toggle');
        (0, _jquery2.default)('.show-shop').attr('href', prev_url);
        return ToggleTransition;
    }
};